import React, { useState , useEffect } from 'react';
import AdminLayout from '../../components/admin-layout';
import CMHeader from '../../PageComponentData/Common/Pageheader';
import {getUserApi, ReferralConsultationHistory , RefferListByID } from "../../apis";
import { IoWallet } from "react-icons/io5";
import { FlagIcon } from "@heroicons/react/24/solid";
import { useLocation, useNavigate } from "react-router-dom";
import { FcPaid } from 'react-icons/fc';
import Placeholder from '../../components/placeholder';
import { BiInfoCircle } from "react-icons/bi";
import NoConsultation from '../../lottiefiles/no_consultation.json';
import Nodoctorreferral from '../../lottiefiles/doctor_refer.json';
import loader from '../../lottiefiles/loader.json';
import { MdOutlineAutoGraph } from "react-icons/md";
import { BsCurrencyRupee } from "react-icons/bs";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { FaUserGroup } from "react-icons/fa6";

const formatINRCurrency = (n) =>
  new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(Number(n || 0));

const Overview = ({ grandTotal = 0 }) => (
  <div className="overview-section" style={{marginBottom:"20px"}}>
     <div className="flex justify-between items-center mb-3">
                      <p className="text-coalBlack capitalize headingText col-span-2">
                        overview 
                      </p>
                    
                    </div>
             
    <div className="card total-earnings-card">
    <div className="pb-4" style={{borderBottom:"1px solid white"}}>
                             <div className="inline-flex gap-2 items-center w-full relative">
                               <div className="flex items-center gap-2">
                                 <IoWallet className="text-2xl text-white-500 m-auto  p-px rounded-full border border-white/25" />
                                 <span className="headingText  ms-1">Total Earnings</span>
                               </div>
                             
                                 {/* <div className="ms-auto group/info hover:shadow-md rounded-full">
                                   <BiInfoCircle className="text-2xl text-white-700 " />
                                   <p className="smallText text-white absolute bg-coalBlack -right-2  p-3  lg:!leading-6 top[35px] smallText-v1 transition-all ease-linear duration-200 invisible group-hover/info:visible shadow-sm rounded-md">
                                     Earnings from completing the referral milestone consultation.
                                    
                                     <span className="size-3 rounded-sm bg-coalBlack absolute top-[-5px] right-3.5 rotate-45"></span>
                                   </p>
                                 </div> */}
                               
                             </div>
                           </div>
      <p className="total-earnings-amount">{formatINRCurrency(grandTotal)}</p>
    </div>
  </div>
);

const ReferralHistoryList = ({ onAllTransactionIds = () => {}, onTotals = () => {} }) => {
  const [referralData, setReferralData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [profileData, setprofileData] = useState('');
  const [selectedItem, setSelectedItem] = useState(null);
  const [imgErrors, setImgErrors] = useState({}); // Track image errors by item._id
const [totalrefferredhistory,settotalrefferredhistory]=useState();
  // ... your existing fetchData, fetchDataReferral, openModal, closeModal, useEffect code here ...
// INR currency formatter
  const inr = React.useMemo(() => new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }), []);

  const fetchData = async () => {
    try {
      const res = await getUserApi();
      if (res.status === 200) {
        console.log("profile", res?.data?.Profile)
        setprofileData(res?.data?.Profile);
        fetchDataRefferal(res?.data?.Profile?.DoctorProfile?._id);    
          

      }
    } catch (error) {
      console.error(error);
    }
  };
   const fetchDataRefferal = async (id) => {
    try {
      setIsLoading(true);
      const res = await RefferListByID(id || profileData?.DoctorProfile?._id);
      if (res.status === 200) {
         setReferralData(res.data.doctors || []);
      const allIds = res?.data?.allTransactionIds ?? [];
        onAllTransactionIds([...new Set(allIds)]);
     const totalReferred = Number(res?.data?.totals?.['total_referred-amount'] ?? 0);
        const totalReferral = Number(res?.data?.totals?.['total_referal_ammount'] ?? 0);
        const grand = totalReferred + totalReferral;
        console.log("send referral1",totalReferral);
settotalrefferredhistory(totalReferred);
          onTotals({ totalReferred, totalReferral, grand });
      }
    } catch (error) {
      console.error(error);
      onTotals({ totalReferred: 0, totalReferral: 0, grand: 0 });
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  
  }, [onTotals]);
 
  const openModal = (item) => {
    setSelectedItem(item);
    setIsModalOpen(true);
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedItem(null);
  };
  const handleImgError = (id) => {
    setImgErrors((prev) => ({ ...prev, [id]: true }));
  };
   const navigate = useNavigate();

  const handleClick = (item) => {
    const isMobile = window.innerWidth <= 767;

    if (isMobile) {
      // ✅ Navigate to /referralmobile with item info
      navigate("/referralmobile", { state: { item } });
    } else {
      // ✅ Open modal for desktop/ipad
      openModal(item);
    }};
  // Display a loading message while fetching data
  if (isLoading) {
    return <div className=" bg-white rounded-lg pt-4 pb-4 flex items-center justify-center mb-28">
        <Placeholder
          title=""
          animationData={loader}
          message=""
        />
      </div>;
  }
  if(referralData.length === 0){
    return <div className=" bg-white rounded-lg pt-4 pb-4 flex items-center justify-center mb-28">
        <Placeholder
          title="No Referrals found."
          animationData={Nodoctorreferral}
          message="Refer anyone to earn."
        />
      </div>;
  }

  return (
    <>
      <div style={{ marginBottom: '60px' }}>
        <div
          className='bg-white border border-gray-300 text-coalBlack p-4 rounded-xl mt-4  shadow-blue_dropshadow min-h-32 flex flex-col'
          // onClick={() => setActiveTab('milestone')}
          style={{ cursor: 'pointer', width:'100%',marginBottom:"20px" }}
        >
          <div className="pb-4">
            <div className="inline-flex gap-2 items-center">
         <FaUserGroup className="text-2xl text-accent m-auto  p-px rounded-full" />
              <span className="headingText  ms-1">Referral History</span>
            </div>
          </div>
          <div className="flex items-center pt-5 mt-auto border-t border-t-px border-gray-300/75 relative">
            <p className="highlightText ">
             {console.log("send referral",totalrefferredhistory)}
              {inr.format(Number(totalrefferredhistory || 0))}
            </p>
            {/* <div className="ms-auto group/info">
              <BiInfoCircle className="text-2xl text-gray-700" />
              <p className="baseText text-white absolute bg-coalBlack right-[-7px] p-1  lg:!leading-4 bottom-[-53px] shadow-sm rounded-lg  transition-all ease-linear duration-200 invisible group-hover/info:visible">
                The amount is based on the milestone consultation you have finished!
                <span className="size-3 rounded-sm bg-coalBlack absolute top-[-5px] right-3.5 rotate-45"></span>
              </p>
            </div> */}
          </div>
        </div>
        {referralData.map((item) => {
          const firstLetter = item.DoctorName ? item.DoctorName.charAt(0).toUpperCase() : '';
          const isImgError = imgErrors[item._id];

          return (
            <div
              className="rh-item"
              key={item._id}
              // onClick={() => openModal(item)}
                   onClick={() => handleClick(item)}
              style={{ cursor: 'pointer' }}
            >
              {!isImgError && item.coverPic ? (
                <img
                  src={`${process.env.REACT_APP_API_URL}/${item.coverPic}`}
                  alt={item.DoctorName}
                  className="rh-avatar"
                  onError={() => handleImgError(item._id)}
                />
              ) : (
                <div className="rh-avatar fallback-avatar">
                  {firstLetter}
                </div>
              )}
              <p className="rh-name">{item.DoctorName || ''}</p>
              <span className="rh-amount"> Earned ₹ {item.referredTotal || 0}</span>
            </div>
          );
        })}
      </div>
      <Modal isOpen={isModalOpen} onClose={closeModal} item={selectedItem} />
    </>
  );
};

const MyMilestoneContent = ({ allTransactionIds = [] ,totals}) => {
  // (A) ids
  const [localIds, setLocalIds] = useState([]);
  const effectiveIds = allTransactionIds?.length ? allTransactionIds : localIds;

  // (B) data + ui state
  const [groups, setGroups] = useState([]); // array of results (one per transactionId)
  const [expanded, setExpanded] = useState({}); // { [transactionId]: boolean }
  const [loading, setLoading] = useState(true);
console.log("totals are",totals);
const inr = React.useMemo(() => new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }), []);
  // (C) fetch ids locally if parent didn't pass any
  useEffect(() => {
    if (allTransactionIds?.length) return;
    (async () => {
      try {
        const u = await getUserApi();
        const docId = u?.data?.Profile?.DoctorProfile?._id;
        if (!docId) { setLocalIds([]); return; }
        const r = await RefferListByID(docId);
        const ids = r?.data?.allTransactionIds ?? [];
        setLocalIds([...new Set(ids)]);
      } catch (e) {
        console.error(e);
        setLocalIds([]);
      }
    })();
  }, [allTransactionIds]);

  
useEffect(() => {
  (async () => {
    setLoading(true);
    try {
      const toFlatIdList = (input) =>
        Array.from(
          new Set(
            (Array.isArray(input) ? input : [])
              .flat(Infinity)
              .filter(id => typeof id === 'string' && id.trim().length > 0)
          )
        );

      const flatIds = toFlatIdList(effectiveIds);
      if (flatIds.length === 0) {
        setGroups([]);
        setExpanded({}); // ensure nothing is expanded when no data
        setLoading(false);
        return;
      }

      const data = await ReferralConsultationHistory({ transactionIds: flatIds });
      const results = data?.data?.data?.results ?? [];

      // Optional: sort (e.g., newest first by first item's createdAt)
      const sorted = results.slice().sort((a, b) => {
        const da = new Date(a?.items?.[0]?.createdAt || 0).getTime();
        const db = new Date(b?.items?.[0]?.createdAt || 0).getTime();
        return db - da;
      });

      setGroups(sorted);

      // OPEN ONLY THE FIRST TRANSACTION TIMELINE
      const firstTxId = sorted[0]?.transactionId;
      setExpanded(firstTxId ? { [firstTxId]: true } : {});
    } catch (e) {
      console.error('Failed to load consultation history:', e);
      setGroups([]);
      setExpanded({});
    } finally {
      setLoading(false);
    }
  })();
}, [effectiveIds]);


  // helpers
  const formatINR = n => new Intl.NumberFormat('en-IN').format(Number(n || 0));
  const overallReferralTotal = groups.reduce(
    (sum, g) => sum + Number(g?.referraltransactionTotal || 0),
    0
  );
  const toggle = tx => setExpanded(prev => ({ ...prev, [tx]: !prev[tx] }));
  const ordinal = n => (n === 1 ? 'First' : n === 2 ? 'Second' : n === 3 ? 'Third' : `${n}th`);

  return (
    <div style={{height:"100%",marginBottom:"80px"}}>
      {loading ? (
       <div className=" bg-white rounded-lg pt-4 pb-4 flex items-center justify-center mb-28">
        <Placeholder
          title=""
          animationData={loader}
          message=""
        />
      </div>
      ) : groups.length === 0 ? (
        <div className=" bg-white rounded-lg pt-4 pb-4 flex items-center justify-center mb-28">
        <Placeholder
          title="No Consultation History found"
          animationData={NoConsultation}
          message="No Consultation Transaction History found , complete consultations to earn."
        />
      </div>
      ) : (
        <>
          {/* Overall earnings across all groups */}
          <div
          className='bg-white border border-gray-300 text-coalBlack p-4 rounded-xl mt-4  shadow-blue_dropshadow min-h-32 flex flex-col'
          // onClick={() => setActiveTab('milestone')}
          style={{ cursor: 'pointer', width:'100%' ,marginBottom:"20px"}}
        >
          <div className="pb-4">
            <div className="inline-flex gap-2 items-center">
              <MdOutlineAutoGraph className="text-2xl text-accent m-auto  p-px rounded-full" />
              <span className="headingText  ms-1">My Milestone</span>
            </div>
          </div>
          <div className="flex items-center pt-5 mt-auto border-t border-t-px border-gray-300/75 relative">
            <p className="highlightText ">
             
              {inr.format(Number(totals || 0))}
            </p>
            {/* <div className="ms-auto group/info">
              <BiInfoCircle className="text-2xl text-gray-700" />
              <p className="baseText text-white absolute bg-coalBlack right-[-7px] p-1  lg:!leading-4 bottom-[-53px] shadow-sm rounded-lg  transition-all ease-linear duration-200 invisible group-hover/info:visible">
                The amount is based on the milestone consultation you have finished!
                <span className="size-3 rounded-sm bg-coalBlack absolute top-[-5px] right-3.5 rotate-45"></span>
              </p>
            </div> */}
          </div>
        </div>

          {/* One milestone header + timeline per transaction group */}
          {groups.map(group => (
            <div key={group.transactionId} style={{}}>
              <div
                className="milestone-item-container"
                onClick={() => toggle(group.transactionId)}
                style={{ cursor: 'pointer' }}
                role="button"
              >
                        <FlagIcon className="w-4 h-4 text-blue-500" style={{width:"60px" , height:"20px"}}/>
                <p className="milestone-text">
                  {`You have earned ₹ ${formatINR(group.referraltransactionTotal)} for completing ${group.total} consultations`}
                </p>
                <span className="amount-badge">
                  ₹ {formatINR(group.referraltransactionTotal)}
                </span>
              </div>

              {expanded[group.transactionId] && (
                <div className="milestone-timeline">
                  {(group.items || []).map((m, i) => (
                    <div
                      key={m?._id || `${group.transactionId}-${i}`}
                      className="milestone-item completed"
                    >
                      <div className="milestone-marker"></div>
                      <div className="milestone-content">
                        <p>{`${ordinal(i + 1)} consultation completed`}</p>
                        <p className="milestone-date">
                          {new Date(m?.createdAt).toLocaleString('en-IN', {
                            day: 'numeric',
                            month: 'short',
                            year: 'numeric',
                            hour: 'numeric',
                            minute: '2-digit',
                            hour12: true,
                          })}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </>
      )}
    </div>
  );
};

const Modal = ({ isOpen, onClose, item }) => {
  
  const [groups, setGroups] = useState([]);   
  const [expanded, setExpanded] = useState({});   
  const [isLoading, setIsLoading] = useState(true);

  const formatINR = n => new Intl.NumberFormat('en-IN').format(Number(n || 0));
  const ordinal = n => (n === 1 ? 'First' : n === 2 ? 'Second' : n === 3 ? 'Third' : `${n}th`);

  const normalizeIds = (it) => {
    const raw = Array.isArray(it?.transactionIds)
      ? it.transactionIds
      : it?.transactionId
        ? [it.transactionId]
        : [];
    return Array.from(
      new Set(
        raw
          .flat(Infinity)
          .filter(id => typeof id === 'string' && id.trim().length > 0)
      )
    );
  };

  useEffect(() => {
    if (!isOpen) return;

    (async () => {
      setIsLoading(true);
      try {
        const ids = normalizeIds(item);
        if (ids.length === 0) {
          setGroups([]);
          setExpanded({});
          setIsLoading(false);
          return;
        }

        const response = await ReferralConsultationHistory({ transactionIds: ids });
        const results = response?.data?.data?.results ?? [];

        // Optional: sort groups by newest item timestamp descending
        const sorted = results.slice().sort((a, b) => {
          const da = new Date(a?.items?.[0]?.createdAt || 0).getTime();
          const db = new Date(b?.items?.[0]?.createdAt || 0).getTime();
          return db - da;
        });

          setGroups(sorted);

      // ONLY the first group open on initial load
      const firstTxId = sorted[0]?.transactionId;
      setExpanded(firstTxId ? { [firstTxId]: true } : {});
        
      } catch (e) {
        console.log('Failed to fetch referral consultation history:', e);
        setGroups([]);
        setExpanded({});
      } finally {
        setIsLoading(false);
      }
    })();
  }, [isOpen, item]);

  if (!isOpen) return null;

  const toggle = (tx) => setExpanded(prev => ({ ...prev, [tx]: !prev[tx] }));

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button onClick={onClose} className="modal-close-btn">Close</button>

        {isLoading ? (
          <div className=" bg-white rounded-lg pt-4 pb-4 flex items-center justify-center mb-28">
        <Placeholder
          title=""
          animationData={loader}
          message=""
        />
      </div>
        ) : groups.length === 0 ? (
        <div className=" bg-white rounded-lg pt-4 pb-4 flex items-center justify-center mb-28">
        <Placeholder
          title="No Consultation History found."
          animationData={NoConsultation}
          message="No Consultation Transaction History is found , complete Consultations to earn."
        />
      </div>
        ) : (
          <>
            {groups.map(group => {
              const tx = group?.transactionId || '';
              // Choose which total to display; API provides both referredtransactionTotal and referraltransactionTotal
              const total = Number(group?.referredtransactionTotal ?? group?.referraltransactionTotal ?? 0);
 const firstDoctorName = group?.items?.[0]?.doctor?.DoctorName ?? 'Unknown Doctor';
              return (
                <div key={tx}>
                  <div
                    className="milestone-item-container"
                    onClick={() => toggle(tx)}
                    style={{ cursor: 'pointer' }}
                    role="button"
                  >
                     <FlagIcon className="w-4 h-4 text-blue-500" style={{width:"60px" , height:"20px"}}/>
                    <p className="milestone-text">
                      {`You have earned ₹  ${formatINR(total)} from your referral ${firstDoctorName} completing a consulation.`}
                    </p>
                    <span className="amount-badge">₹ {formatINR(total)}</span>
                  </div>

                  {expanded[tx] && (
                    <div className="milestone-timeline">
                      {(group.items || []).map((milestone, index) => {
                        const label = `${ordinal(index + 1)} consultation completed`;
                        return (
                          <div key={milestone?._id || `${tx}-${index}`} className="milestone-item completed">
                            <div className="milestone-marker"></div>
                            <div className="milestone-content">
                              <p>{label}</p>
                              <p className="milestone-date">
                                {new Date(milestone.createdAt).toLocaleString('en-IN', {
                                  day: 'numeric',
                                  month: 'short',
                                  year: 'numeric',
                                  hour: 'numeric',
                                  minute: '2-digit',
                                  hour12: true,
                                })}
                              </p>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })}
          </>
        )}
      </div>
    </div>
  );
};

const RecentConsultation = ({ allTransactionIds = [] }) => {
  // (A) local ids + effective ids
  const [localIds, setLocalIds] = useState([]);
  const effectiveIds = allTransactionIds?.length ? allTransactionIds : localIds;
console.log("the ids are",effectiveIds)
  // (B) data + ui state
  const [groups, setGroups] = useState([]); // array of results (one per transactionId)
  const [expanded, setExpanded] = useState({}); // { [transactionId]: boolean }
  const [loading, setLoading] = useState(true);
const [doctors, setDoctors] = useState([]);

useEffect(() => {
  if (allTransactionIds?.length) return;
  let ignore = false;
  (async () => {
    try {
      const u = await getUserApi();
      if (ignore) return;
      const docId = u?.data?.Profile?.DoctorProfile?._id;
      if (!docId) { setLocalIds([]); setDoctors([]); return; }
      
      const r = await RefferListByID(docId);
      if (ignore) return;

      const transactionIds = (r?.data?.doctors || []).flatMap(doc => doc.transactionId || []);
      setLocalIds(Array.from(new Set(transactionIds)));

      setDoctors(r?.data?.doctors || []);
    } catch (e) {
      if (!ignore) { console.error(e); setLocalIds([]); setDoctors([]); }
    }
  })();
  return () => { ignore = true; };
}, [allTransactionIds?.length]);


// 3) Dedupe API calls based on a stable key
const lastReqKeyRef = React.useRef('');

useEffect(() => {
  let ignore = false;
  (async () => {
    setLoading(true);
    try {
      const toFlatIdList = (input) =>
        Array.from(
          new Set(
            (Array.isArray(input) ? input : [])
              .flat(Infinity)
              .filter(id => typeof id === 'string' && id.trim().length > 0)
          )
        );

      const flatIds = toFlatIdList(effectiveIds);
      const reqKey = flatIds.slice().sort().join('|'); // stable key for dedupe

      if (flatIds.length === 0) {
        if (!ignore) { setGroups([]); setExpanded({}); setLoading(false); }
        return;
      }

      // Skip if same as last request (prevents StrictMode double and identity thrash)
      if (lastReqKeyRef.current === reqKey) {
        if (!ignore) setLoading(false);
        return;
      }
      lastReqKeyRef.current = reqKey;

      const data = await ReferralConsultationHistory({ transactionIds: flatIds });
      if (ignore) return;

      const results = data?.data?.data?.results ?? [];
      const sorted = results.slice().sort((a, b) => {
        const da = new Date(a?.items?.[0]?.createdAt || 0).getTime();
        const db = new Date(b?.items?.[0]?.createdAt || 0).getTime();
        return db - da;
      });

      if (!ignore) {
        setGroups(sorted);
        const firstTxId = sorted[0]?.transactionId;
        setExpanded(firstTxId ? { [firstTxId]: true } : {});
      }
    } catch (e) {
      if (!ignore) { console.error('Failed to load consultation history:', e); setGroups([]); setExpanded({}); }
    } finally {
      if (!ignore) setLoading(false);
    }
  })();
  return () => { ignore = true; };
}, [effectiveIds]);


  
  const formatINR = n => new Intl.NumberFormat('en-IN').format(Number(n || 0)); // not used in this view
  const overallReferralTotal = groups.reduce(
    (sum, g) => sum + Number(g?.referraltransactionTotal || 0),
    0
  ); 
  const toggle = tx => setExpanded(prev => ({ ...prev, [tx]: !prev[tx] })); // not used in this view
  const ordinal = n => (n === 1 ? 'First' : n === 2 ? 'Second' : n === 3 ? 'Third' : `${n}th`); // not used here

  const now = new Date();
  const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
  const nextMonthStart = new Date(now.getFullYear(), now.getMonth() + 1, 1);

const lastGroupItems = groups.length > 0 ? groups[groups.length - 1].items ?? [] : [];

const monthItems = lastGroupItems.filter(it => {
  const t = new Date(it?.createdAt || 0).getTime();
  return t >= monthStart.getTime() && t < nextMonthStart.getTime();
});

  const isLoading = loading;

  return (
    
    <div className="bg-white rounded-2xl overflow-y-auto scrollbar h-full">
      <h1 className="text-coalBlack subHeadingText p-4 py-5 sticky top-0 bg-white border-b border-gray-100">
       Recently  Completed Referral Consultation
      </h1>

      <div className="p-4">
      {isLoading ? (
  <div className="bg-white rounded-lg pt-4 pb-4 flex items-center justify-center mb-28">
    <Placeholder title="" animationData={loader} message="" />
  </div>
) : doctors.length === 0 ? (
  <div className="bg-white rounded-lg pt-4 pb-4 flex items-center justify-center mb-28">
    <Placeholder
      title="No Referred Doctors Found"
      animationData={NoConsultation}
      message="You have not referred any doctors yet."
    />
  </div>
) : (
  <div className="space-y-3">
    {doctors.map((doctor) =>
      doctor.ReferralTransaction.map((transaction, idx) => {
        const milestoneNumber = transaction.milestone_details?.milestones || 0;
        const ordinal = (n) =>
          n === 1 ? '1st' : n === 2 ? '2nd' : n === 3 ? '3rd' : `${n}th`;

        return (
          <div key={`${doctor._id}-${transaction._id || idx}`} className="milestone completed">
            <div className="milestone-content">
              <div style={{ display: 'flex', gap: '10px' }}>
                <div className="bg-green-100 rounded-full size-10 min-w-10 inline-flex justify-center items-center">
                  <FcPaid className="text-2xl m-auto" />
                </div>
                <p>
                  Your referred doctor, {doctor.DoctorName}, has completed their {ordinal(milestoneNumber)} milestone.
                </p>
              </div>
              <p className="milestone-date" style={{ paddingLeft: '50px' }}>
                {new Date(transaction.createdAt).toLocaleString('en-IN', {
                  day: 'numeric',
                  month: 'short',
                  year: 'numeric',
                  hour: 'numeric',
                  minute: '2-digit',
                  hour12: true,
                  timeZone: 'Asia/Kolkata',
                })}
              </p>
            </div>
          </div>
        );
      })
    )}
  </div>
)}

      </div>
    </div>
  );
};

const TabbedView = ({ onTotals }) => {

  const location = useLocation(); 
 
  const [activeTab, setActiveTab] = useState('referral');
  const [allTransactionIds, setAllTransactionIds] = useState([]);
  const [totals, setTotals] = useState({ totalReferred: 0, totalReferral: 0, grand: 0 });
  // optional: keep Tab UI totals in sync while also lifting to parent
  const handleChildTotals = React.useCallback((t) => {
    setTotals({
      totalReferred: Number(t?.totalReferred || 0),
      totalReferral: Number(t?.totalReferral || 0),
      grand: Number(t?.grand || 0),
    });
    onTotals?.(t);
  }, [onTotals]);
  // INR currency formatter
  const inr = React.useMemo(() => new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }), []);

  useEffect(() => {
    if (location.state?.type) {
      const type = location.state.type;

      // Logic to switch tabs based on the type passed
      if (type === 'ReferralMilestoneReward') {
        setActiveTab('milestone');
      } else if (type === 'ReferredMilestoneReward') {
        setActiveTab('referral');
      }
    }
  }, [location.state]);
  
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 767px)");
    setIsMobile(mediaQuery.matches);

    const handler = (e) => setIsMobile(e.matches);
    mediaQuery.addEventListener("change", handler);

    return () => mediaQuery.removeEventListener("change", handler);
  }, []);

  return (
    <div className="milestone-section">
      {/* <div className="tabs" style={{display: isMobile ? "block" : "",}}>
        <div
          className='bg-white border border-gray-300 text-coalBlack p-4 rounded-xl mt-4  shadow-blue_dropshadow min-h-32 flex flex-col'
          onClick={() => setActiveTab('milestone')}
          style={{ cursor: 'pointer', width:'100%' }}
        >
          <div className="pb-4">
            <div className="inline-flex gap-2 items-center">
              <MdOutlineAutoGraph className="text-2xl text-accent m-auto  p-px rounded-full" />
              <span className="headingText  ms-1">My Milestone</span>
            </div>
          </div>
          <div className="flex items-center pt-5 mt-auto border-t border-t-px border-gray-300/75 relative">
            <p className="highlightText ">
             
              {inr.format(Number(totals.totalReferral || 0))}
            </p>
            
          </div>
        </div>

        <div
          className='bg-white border border-gray-300 text-coalBlack p-4 rounded-xl mt-4  shadow-blue_dropshadow min-h-32 flex flex-col'
          onClick={() => setActiveTab('referral')}
          style={{ cursor: 'pointer', width:'100%' }}
        >
          <div className="pb-4">
            <div className="inline-flex gap-2 items-center">
              <FaUserGroup className="text-2xl text-accent m-auto  p-px rounded-full" />
              <span className="headingText  ms-1">Referral History</span>
            </div>
          </div>
          <div className="flex items-center pt-5 mt-auto border-t border-t-px border-blue-100 relative">
            <p className="highlightText ">
              
              {inr.format(Number(totals.totalReferred || 0))}
            </p>
          
          </div>
        </div>
      </div> */}
 <div className="milestone-section">
            <div className="tabs" style={{marginBottom:"20px" ,borderBottom:' 2px solid #e0e0e0' }}>
                <h3
                    className={activeTab === 'milestone' ? 'active-tab' : ''}
                    onClick={() => setActiveTab('milestone')}
                    style={{ cursor: 'pointer', paddingBottom:"20px" }}
                >
                    My Milestone
                </h3>
                <h3
                    className={activeTab === 'referral' ? 'active-tab' : ''}
                    onClick={() => setActiveTab('referral')}
                    style={{ cursor: 'pointer', paddingBottom:"20px"}}
                >
                    Referral History
                </h3>
            </div>
            </div>
      {activeTab === 'milestone'
        ? <MyMilestoneContent allTransactionIds={allTransactionIds} totals={totals.totalReferral} />
        : <ReferralHistoryList onAllTransactionIds={setAllTransactionIds}      onTotals={handleChildTotals}  />}
    </div>
  );
};

const EarningsDashboard = () => {

const [grandTotal, setGrandTotal] = useState(0);
const handleTotals = React.useCallback((t) => {
  setGrandTotal(Number(t?.grand || 0));
}, []);
// ..
  return (
    <AdminLayout headerTxt={'Referral Management'}>
      <CMHeader headertxt='Referral Management' backbtn />
      <div className="p-0 md:p-4">
     
          <div className="referral-container">   <section className="py-5 p-4 rounded-2xl gap-x-4 bg-transparent md:bg-white" style={{ width:'100%'}}>
          <div className="dashboard-container">
            <Overview grandTotal={grandTotal} />

            {/* Wire TabbedView to update totals up */}
            <div className="main-content">
              <TabbedView  onTotals={handleTotals}
                // Expose a way for ReferralHistoryList to push totals upward
                // by threading a callback down to ReferralHistoryList
                // e.g., TabbedView passes onTotals={setTotals} and calls handleTotals here
              />
            </div>
          </div> </section>
          
  <div className="hidden lg:block bg-white rounded-2xl overflow-y-auto scrollbar h-full">
 <section className="py-5 bg-white p-4 rounded-2xl  gap-x-4" style={{ width:'100%' , height:"100%"}}>
            {/* Wire TabbedView to update totals up */}
            <div className="main-content">
         <RecentConsultation />
            </div>
</section></div>
          
          </div>
       
      </div>
    </AdminLayout>
  );
};

export default EarningsDashboard;
